/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.


const {
  Component
} = React
import { captureExceptions } from 'utils/SentryHelpers'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import IconSVG from 'svg-inline-react'

import SearchResultTypesEnum from 'constants/SearchResultTypesEnum'

import ResultPreviewUser from './ResultPreview/User'
import ResultPreviewConversation from './ResultPreview/Conversation'

import './ResultPreview.styl'

class ResultPreview extends Component {
  static initClass() {
    this.propTypes = {
      item: PropTypes.object.isRequired
    }
  }

  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <div className="ResultPreview">
        {(() => { switch (this.props.item.type) {
          case SearchResultTypesEnum.endUser.key:
            return <ResultPreviewUser endUser={this.props.endUser} />
          case SearchResultTypesEnum.conversation.key:
            return <ResultPreviewConversation conversation={this.props.conversation} />
        } })()}
      </div>
    )
  }
}
ResultPreview.initClass()

const ResultPreviewContainer = Marty.createContainer(ResultPreview, {
  listenTo: ['stores.EndUserStore', 'stores.ConversationStore'],

  fetch: {
    endUser() {
      if (this.props.item.type === SearchResultTypesEnum.endUser.key) {
        return this.app.stores.EndUserStore.getOrFetchEndUser(this.props.item.id)
      }
    },

    conversation() {
      if (this.props.item.type === SearchResultTypesEnum.conversation.key) {
        return this.app.stores.ConversationStore.getOrFetchConversation(this.props.item.id)
      }
    }
  },

  failed(errors) {
    captureExceptions(errors)
    return <div />
  }
})

export default ResultPreviewContainer



// WEBPACK FOOTER //
// ./src/scripts/components/GlobalSearch/ResultPreview.js